<template>
  <FriendlyRecaptchaWidget
    v-if="location"
    :location="location"
    :site-name="formName"
    @widget-completed="onWidgetCompleted"
    @widget-error="onWidgetError"
    @widget-expire="onWidgetExpire"
    @widget-reset="onWidgetReset"
    @reset="onSetReset"
  />
</template>
<script setup>
import { ref, getCurrentInstance, onBeforeUnmount } from 'vue'
import { FriendlyRecaptchaWidget, useConfigDynamic } from '@common/lib-vue-common'

const { appContext } = getCurrentInstance()
const { isEnabled } = useConfigDynamic()

const formLocation = appContext.config.globalProperties.formLocation
const formName = appContext.config.globalProperties.formName

const FF_KEY_MAP = {
  login: {
    key: 'enable.web.friendly.captcha.login',
    location: 'login'
  },
  'activate-account': {
    key: 'enable.web.friendly.captcha.activate',
    location: 'account'
  }
}

const location = ref()
const reset = ref(() => {})

const findWidget = () => {
  const elementId = `frc-captcha_${location.value}${formName ? `_${formName}` : ''}`
  return document.getElementById(elementId)
}
const validateWidgetData = () => {
  if (!formLocation) {
    return
  }

  const widgetLocationFF = FF_KEY_MAP[formLocation]
  if (!widgetLocationFF) {
    return
  }

  const ffDefaultValue = window.configDynamic
    ? window.configDynamic[widgetLocationFF.key] === 'true'
    : false
  if (!isEnabled(widgetLocationFF.key, ffDefaultValue)) {
    return
  }

  location.value = widgetLocationFF.location
}
const sendEvent = (eventName, eventParams) => {
  const widgetElement = findWidget()
  if (widgetElement) {
    widgetElement.dispatchEvent(
      new CustomEvent(`${eventName}${formName ? `-${formName}` : ''}`, eventParams)
    )
  }
}
const onWidgetCompleted = event => {
  if (event?.detail) {
    sendEvent('widget-completed', { detail: event.detail })
  }
}
const onWidgetError = () => {
  sendEvent('widget-error')
}
const onWidgetExpire = () => {
  sendEvent('widget-expire')
}
const onWidgetReset = () => {
  sendEvent('widget-reset')
}
const onSetReset = (resetMethod = () => {}) => {
  reset.value = resetMethod

  const widgetElement = findWidget()
  if (widgetElement) {
    widgetElement.addEventListener(`onReset${formName ? `-${formName}` : ''}`, onReset)
  }
}
const onReset = () => {
  reset.value()
}

validateWidgetData()

onBeforeUnmount(() => {
  const widgetElement = findWidget()
  if (widgetElement) {
    widgetElement.removeEventListener(`onReset${formName ? `-${formName}` : ''}`, onReset)
  }
})
</script>
